module.exports = __webpack_public_path__ + "static/media/elctrec.2d0ef8f6.jpg";